import { useState, useEffect } from "react";
import { getSpotlightCarouselWidget } from "../api/widgets/spotlightCarousel/requests";

function useStoryblokSpotlightCarouselWidget() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getSpotlightCarouselWidget()
      .then((data) => {
        if (data) {
          setData(data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setIsLoading(false))
  }, []);

  return [data, isLoading];
}

export { useStoryblokSpotlightCarouselWidget };
